import React from 'react';
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  Button, 
  Typography,
  Box, 
  TextField,
  Divider,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from '@mui/material';

import { SimpleValidators, CONST } from '../../../../../utils';

export default function CsvDialog({ open, onClose, onConfirm }) {

  const [loading, isLoading] = React.useState(false);
  const [clients, setClients] = React.useState({});
  const [status, setStatus] = React.useState({});
  const [dates, setDates] = React.useState({
    from  : SimpleValidators.Dates(),
    to    : SimpleValidators.Dates()
  });
  const [error, setError] = React.useState({
    dates   : false,
    status  : false,
    clients : false
  });

  React.useEffect(() => {
    performValidations();
  },[dates, status, clients]);

  const handleDate = async(e) => {
    setDates({...dates,[e.target.name] : e.target.value});
  }

  const handleStatus = async (e) => {
    const delta = Object.keys(status).includes(e.target.name) ? status[e.target.name] : false;
    setStatus({...status, [e.target.name] : !delta});
  }

  const handleClients = async (e) => {
    const delta = Object.keys(clients).includes(e.target.name) ? clients[e.target.name] : false;
    setClients({...clients, [e.target.name] : !delta});
  }

  const handleClose = async() => {
    if(loading){
      return;
    }

    var datesReset = {...dates};

    Object.keys(datesReset).forEach(x => {
      datesReset[x] = SimpleValidators.Dates();
    });

    setDates(datesReset);
    setStatus({});
    setClients({});
    setError({
      dates   : false,
      status  : false,
      clients : false
    });

    onClose();
  }

  const handleConfirm = async() => {
    onConfirm(dates, status, clients, getResponse);
    isLoading(true);
  }

  const performValidations = async() => {
    var results = {
      dates   : false,
      status  : false,
      clients : false
    };

    results.dates = await validateDates();
    results.status = await validateStatuses(); 
    results.clients = await validateClients(); 

    setError(results);
  }
  const validateDates = async() => {
    const result =  dates.from > dates.to;
    return result;
  }

  const validateStatuses = async() => {
    const keys = Object.keys(status);
    var result = true;
    
    if(keys.length < 1){
      return true;
    }

    keys.forEach(x => {
      if(status[x]){
        result = false;
      }
    })
    return result;
  }

  const validateClients = async() => {
    const keys = Object.keys(clients);
    var result = true;
    
    if(keys.length < 1){
      return true;
    }

    keys.forEach(x => {
      if(clients[x]){
        result = false;
      }
    })
    return result;
  }

  const getResponse = async(response) => {
    isLoading(false);

    if(response.success){
      handleClose();
      return;
    }

    alert(response.message);
  }

  const handleAllStatus = async() => {
    var result  = {}
    CONST.PRODUCTION_CSV_REPORT.map((item) => {
      result = {
        ...result, 
        [item.INIT.ID] : true,
        [item.ERROR.ID] : true,
        [item.PASS.ID] : true
      }
    });

    setStatus(result);
  }

  const handleAllClients = async() => {
    var result  = {}
    CONST.KLINE_CLIENTS.map((item) => {
      result = {
        ...result, 
        [item] : true
      }
    });

    setClients(result);
  }

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      PaperProps={{
        sx: {
          width: '75vw',
          maxWidth: 'none',
        }
      }}
    >
      <DialogTitle >CSV Report</DialogTitle>
      <Divider />
      <DialogContent>
      <Box
        sx={{
          display:'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant='body1' >
          Date Range
        </Typography>
        <Divider />
        <Box
          sx={{
            gap:2,
            padding:2,
            display:'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <TextField size='small' type='date' fullWidth name='from' onChange={handleDate} value={dates.from}/>
          <TextField size='small' type='date' fullWidth name='to'onChange={handleDate} value={dates.to}/>
        </Box>
        
        <Box
          sx={{
            display:'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap:1,
            my: 1,
          }}
        >
          <Typography variant='body1' >
            Statuses
          </Typography>
          <Button variant='outlined' size='small' onClick={handleAllStatus}>
            All
          </Button>
        </Box>

        <Divider />

        <Box
          sx={{
            gap:1,
            display:'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          {CONST.PRODUCTION_CSV_REPORT.map((item) => (
            <Box>
              <Typography fontWeight='bold'>{item.TITLE}</Typography>
              <Box
                sx={{
                  display:'flex',
                  flexDirection: 'column',
                }}
              >
                <FormControlLabel control={<Checkbox name={item.INIT.ID} value={item.INIT.ID} onChange={handleStatus} checked={Object.keys(status).includes(`${item.INIT.ID}`) ? status[item.INIT.ID] : false}/>} label={item.INIT.DESC} />
                <FormControlLabel control={<Checkbox name={item.ERROR.ID} value={item.ERROR.ID} onChange={handleStatus} checked={Object.keys(status).includes(`${item.ERROR.ID}`) ? status[item.ERROR.ID] : false}/>} label={item.ERROR.DESC} />
                <FormControlLabel control={<Checkbox name={item.PASS.ID} value={item.PASS.ID} onChange={handleStatus} checked={Object.keys(status).includes(`${item.PASS.ID}`) ? status[item.PASS.ID] : false}/>} label={item.PASS.DESC} />
              </Box>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            display:'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap:1,
            my: 1,
          }}
          
        >
          <Typography variant='body1' >
            Clients
          </Typography>
          <Button variant='outlined' size='small' onClick={handleAllClients}>
            All
          </Button>
        </Box>
        <Divider />
        <Box
          sx={{
            gap:1,
            display:'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'wrap'
          }}
        >
          {CONST.KLINE_CLIENTS.map((item) => (
            <FormControlLabel control={<Checkbox name={item} value={item} onChange={handleClients} checked={Object.keys(clients).includes(`${item}`) ? clients[item] : false}/>} label={item} />
          ))}
        </Box>

      </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Typography
          sx={{
            fontSize:12,
            color:'red'
          }}
        >
          {`${error.dates || error.status || error.clients ? 'Required : ' : ''} ${error.dates ? 'VALID DATE RANGE ' : ''}${error.status ? ' 1 STATUS ' : ''}${error.clients ? ' 1 CLIENT' : ''}`}
        </Typography>
        
        {loading && (
          <CircularProgress />
        )}

        <Button onClick={handleClose} color='secondary' variant='contained' disabled={loading}>Cancel</Button>
        <Button onClick={handleConfirm} variant='contained' disabled={error.dates || error.status || error.clients || loading}>Create CSV</Button>
        
      </DialogActions>
    </Dialog>
  );
}